import { Reducer } from 'redux'
import { IMarketplaceStore } from 'apps/marketplace/store/types'
import { TRANSFIX_LANES_ACTION_TYPES as c } from './actions'
import { TransfixLanes, ITransfixLanesState } from './types'

const initState = {
  data: undefined,
  loading: false,
  error: '',
}

interface ITransfixLanesResponsePayload {
  transfixLanes: TransfixLanes
}

type TransfixLanesActions =
  | { type: c.FETCH_TRANSFIX_LANES_REQUEST }
  | { type: c.FETCH_TRANSFIX_LANES_SUCCESS; payload: ITransfixLanesResponsePayload }
  | { type: c.FETCH_TRANSFIX_LANES_FAILURE; error: string }

/** Reducer */
const transfixLanesReducer: Reducer<ITransfixLanesState, TransfixLanesActions> = (
  state: ITransfixLanesState = initState,
  action: TransfixLanesActions
): ITransfixLanesState => {
  switch (action.type) {
    case c.FETCH_TRANSFIX_LANES_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case c.FETCH_TRANSFIX_LANES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.transfixLanes,
      }
    case c.FETCH_TRANSFIX_LANES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    default:
      return state
  }
}

export default transfixLanesReducer

/** Selectors */
export const selectTransfixLanes = (state: IMarketplaceStore): TransfixLanes | undefined =>
  state.transfixLanes.data

export const isLoadingTransfixLanes = (state: IMarketplaceStore): boolean =>
  state.transfixLanes.loading
